import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getTimezoneDate } from 'utils/date'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import MenuItem from 'material-ui/MenuItem'

import { doc, dirtyRead } from 'selectors/common'
import { propertiesLLEx } from 'selectors/properties'

import Section from 'components/Section'
import dataActions from 'actions/dataActions'
import AddButton from 'components/AddButton'
import EventList from './List'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , events: propertiesLLEx(state)[props.propertyID]
	})
)

export class Events extends Component{
	render(){
		let { props } = this
		let availableFrom= props.property && props.property.availFrom && getTimezoneDate(props.property.availableFrom) || new Date()

		return(
			<Section
				id="property/events"
				title="History"
			>
				<EventList propertyID={props.propertyID} />
			</Section>
		)
	}
}

export default connect(select, dataActions)(Events)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/events/index.js